

import { getProBasicInfo, getProCount, getProNameList, getWeather } from "@/api/project";


export default {
  name: "configuration",
  data() {

    return {
      project: this.$route.query.id ? this.$route.query.id : 20523,
      projectId: null,
      codeId: "",
      newDate: this.moment().format('YYYY/MM/DD HH:mm:ss'),
      infoData: [
        {
          id: 'customer_name',
          key: '项目所属客户',
          val: ''
        }, {
          id: 'contacts_name',
          key: '项目联系人',
          val: ''
        }, {
          id: 'region_name',
          key: '项目地址',
          val: ''
        }, {
          id: 'contacts_phone',
          key: '联系方式',
          val: ''
        },
      ],
      configuration_url: '',
      load: false,
      proNameList: [],
      showInfo: false,
      timer: null,
      weather: {}
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getProNameList()//项目名称list
    this.timer = setInterval(() => {
      this.newDate = this.moment().format('YYYY/MM/DD HH:mm:ss')
    }, 1000)
  },
  mounted() {

  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    
    //项目基本信息
    async getProBasicInfo() {
      this.load = false
      const res = await getProBasicInfo(this.projectId)
      if (res.code === 200) {
        this.load = true
        this.configuration_url = res.data[0].configuration_url
        this.infoData.forEach(el => {
          el.val = res.data[0][el.id]
          if (el.id === 'region_name') {
            el.val = res.data[0]['region_name'] + " " + (res.data[0]['detail_address'] ? res.data[0]['detail_address'] : '')
          }
        });
      }
    },

    //获取下拉菜单 项目列表
    async getProNameList() {
      const res = await getProNameList()
      if (res.code == 200) {
        this.proNameList = res.data
        //用项目list第一个为默认的
        if (!this.projectId) {
          this.projectId = this.$route.query.id ? this.$route.query.id : 20523
          this.project = this.$route.query.id ? this.$route.query.id : 20523
          this.codeId = this.$route.query.adCode ? this.$route.query.adCode : this.proNameList.filter(el => el.id === 20523)[0].adCode
        }
        this.getProBasicInfo()//项目基本信息
        this.getWeather()//获取天气信息
      }
    },

    //选择项目后
    handleChangeProjectId(val) {
      this.projectId = val == 0 ? '' : val
      this.codeId = this.proNameList.filter(el => el.id === val)[0].adCode
      this.getProBasicInfo()//项目基本信息
      this.getWeather()//获取天气信息
    },

    showDetail() {
      this.showInfo = true
    },
    closeInfo() {
      this.showInfo = false
    },
    toEnlarge() {
      window.open(this.configuration_url)
    },



    //获取天气信息
    getWeather() {
      getWeather([this.codeId]).then(res => {
        if(res.code===200){
          this.weather = res.data[0]
          if (this.weather.now.text.indexOf('雨') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/rain.png'))
          } else if (this.weather.now.text.indexOf('雪') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/snow.png'))
          } else if (this.weather.now.text.indexOf('风') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/wind.png'))
          } else if (this.weather.now.text.indexOf('晴') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/sun.png'))
          } else if (this.weather.now.text.indexOf('多云') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/cloudy.png'))
          } else if (this.weather.now.text.indexOf('阴') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/overcast.png'))
          } else if (this.weather.now.text.indexOf('雾') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/fog.png'))
          } else if (this.weather.now.text.indexOf('霾') != -1) {
            this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/Haze.png'))
          }
        }
      })
    }

  },
}
